import { clone as _clone, merge as _merge } from 'lodash';
import {
    STORE_ADD_ORDER,
    STORE_RESET_ORDERS
} from '../constants/store.js';

export const initialState = {
    orders: {}
};

export function storeReducer( state = initialState, action ) {

    switch ( action.type ) {

        case STORE_ADD_ORDER:

            let _orders = _clone( state.orders );
            return Object.assign( {}, state, {
                orders: _merge( _orders, action.orders )
            });

        case STORE_RESET_ORDERS:
            return Object.assign( {}, state, {
                orders: {}
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/store.js